"use strict";

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ClassTransformer_1 = require("./ClassTransformer");

var ClassTransformer_2 = require("./ClassTransformer");

exports.ClassTransformer = ClassTransformer_2.ClassTransformer;

__export(require("./decorators"));

var classTransformer = new ClassTransformer_1.ClassTransformer();

function classToPlain(object, options) {
  return classTransformer.classToPlain(object, options);
}

exports.classToPlain = classToPlain;

function classToPlainFromExist(object, plainObject, options) {
  return classTransformer.classToPlainFromExist(object, plainObject, options);
}

exports.classToPlainFromExist = classToPlainFromExist;

function plainToClass(cls, plain, options) {
  return classTransformer.plainToClass(cls, plain, options);
}

exports.plainToClass = plainToClass;

function plainToClassFromExist(clsObject, plain, options) {
  return classTransformer.plainToClassFromExist(clsObject, plain, options);
}

exports.plainToClassFromExist = plainToClassFromExist;

function classToClass(object, options) {
  return classTransformer.classToClass(object, options);
}

exports.classToClass = classToClass;

function classToClassFromExist(object, fromObject, options) {
  return classTransformer.classToClassFromExist(object, fromObject, options);
}

exports.classToClassFromExist = classToClassFromExist;

function serialize(object, options) {
  return classTransformer.serialize(object, options);
}

exports.serialize = serialize;
/**
 * Deserializes given JSON string to a object of the given class.
 */

function deserialize(cls, json, options) {
  return classTransformer.deserialize(cls, json, options);
}

exports.deserialize = deserialize;
/**
 * Deserializes given JSON string to an array of objects of the given class.
 */

function deserializeArray(cls, json, options) {
  return classTransformer.deserializeArray(cls, json, options);
}

exports.deserializeArray = deserializeArray;
/**
 * Enum representing the different transformation types.
 */

var TransformationType;

(function (TransformationType) {
  TransformationType[TransformationType["PLAIN_TO_CLASS"] = 0] = "PLAIN_TO_CLASS";
  TransformationType[TransformationType["CLASS_TO_PLAIN"] = 1] = "CLASS_TO_PLAIN";
  TransformationType[TransformationType["CLASS_TO_CLASS"] = 2] = "CLASS_TO_CLASS";
})(TransformationType = exports.TransformationType || (exports.TransformationType = {}));